<template>
    <div class="">
        Here would be the User Statistic
    </div>
</template>

<script>
    export default {
        name: "UserStatistic"
    }
</script>

<style>

</style>